import classNames from "classnames";
import styles from "./style.module.scss";

const Section1 = () => {
  return (
    <section className={styles.customContainer}>
      <div className="flex flex-col items-center justify-center pt-16">
        <h1 className={styles.title}>
          Elevate Your <span> Job Evaluation</span>
          Process
        </h1>
        <p className={classNames(styles.description, "pt-8 pb-6")}>
          Welcome to RAStrack, the Role Assessment Score (RAS) platform that is designed to
          streamline your job evaluation process. Our intuitive and secure
          platform makes job evaluations straightforward and efficient.
        </p>
        <p className={classNames(styles.description, "pb-12")}>
          Start your journey towards more effective job evaluations today.
        </p>
      </div>
    </section>
  );
};

export default Section1;
